import * as React from 'react';
import { connect } from 'react-redux';

import { FinancialWorkbook, PortalTextSubmissionDetails } from '../../Models/Api/strongbox.financialportal';
import { ApplicationState } from '../../Store';
import { GetFieldGuideEnabled } from '../../Store/AppSettings';
import { DownloadableFile } from '../../Utils/FileUtils';

import { FieldGuideWizard } from '../FieldGuide/FieldGuideWizard';

import { WorkbooksCard } from './WorkbooksCard';

type InjectedReduxState = {
    fieldGuideEnabled: boolean;
};

type WorkbooksCardContainerProps = {
    workbooks: (FinancialWorkbook | undefined)[];
    workspaceId: string;
    financialRecordId: string | undefined;
    financialRecordCreated: string | undefined;
    onDownload: (files: DownloadableFile[]) => void;
    text?: PortalTextSubmissionDetails;
};

type Props = InjectedReduxState & WorkbooksCardContainerProps;

export const WorkbooksCardContainerComponent: React.FC<Props> = (props): React.ReactElement => {
    const { fieldGuideEnabled, ...workbooksCardProps } = props;

    // Whether the FieldGuide wizard is open. "Connected" is this story's end state; destination
    // selection belongs to M2, so no workbook selection is threaded into the wizard yet.
    const [wizardOpen, setWizardOpen] = React.useState<boolean>(false);

    return (
        <>
            <WorkbooksCard
                {...workbooksCardProps}
                fieldGuideEnabled={fieldGuideEnabled}
                onSendToFieldguide={() => setWizardOpen(true)}
            />
            {wizardOpen && <FieldGuideWizard onClose={() => setWizardOpen(false)} />}
        </>
    );
};

export const WorkbooksCardContainer = connect<InjectedReduxState, {}, WorkbooksCardContainerProps, ApplicationState>(
    (appState: ApplicationState) => {
        return {
            fieldGuideEnabled: GetFieldGuideEnabled(appState),
        };
    }
)(WorkbooksCardContainerComponent);
